<template>
  <div>
    <div class="brand-row" :class="{ collapsed: !isOpen }">
      <div class="brand-mark">{{ ($appName || "پ").charAt(0) }}</div>
      <span class="brand-name" v-show="isOpen">{{ $appName }}</span>
    </div>
    <ul>
      <li :class="{ 'nav-header': true, small: !isOpen }">
        <div
          v-if="$user"
          class="dropdown profile-element"
          :title="!isOpen ? `${$user.name} ${$user.family}` : null"
        >
          <img
            alt="image"
            class="rounded-circle profile-img"
            :src="$user.avatar_url"
            @click="imageClick()"
          />
          <div class="d-none">
            <input type="file" ref="imageInput" @change="changeAvatar()" />
          </div>
          <span class="block m-t-xs font-bold text-light" v-show="isOpen">{{
            $user.name + " " + $user.family
          }}</span>
          <span class="text-muted text-xs block" v-show="isOpen">
            {{ $user.roles && $user.roles[0] ? $user.roles[0].fa_name : "کاربر بدون نقش" }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { userApi } from "@/api/apiManagement";

export default {
  props: {
    isOpen: {
      type: Boolean,
    },
  },
  data() {
    return {
      imageUrl: "",
    };
  },
  methods: {
    imageClick() {
      this.$refs.imageInput.click();
    },
    changeAvatar() {
      this.imageUrl = this?.$refs?.imageInput?.files[0];

      let formData = new FormData();

      formData.append("avatar", this.imageUrl);

      userApi
        .updateAvatar(formData)
        .then(({ data }) => {
          this.$izitoast(
            "success",
            "عملیات موفق",
            "اطلاعات شما با موفقیت ویرایش یافت"
          );

          this.$store.dispatch("userUpdate", res.data.entity);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    },
  },
};
</script>
<style scoped>
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.brand-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 16px 12px;
}

.brand-row.collapsed {
  justify-content: center;
  padding: 16px 8px 12px;
}

.brand-mark {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: linear-gradient(135deg, #818cf8 0%, #4f46e5 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.9rem;
}

.brand-name {
  color: #f1f5f9;
  font-weight: 700;
  font-size: 0.95rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nav-header {
  padding: 12px 16px 18px;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  margin-bottom: 10px;
}

.nav-header.small {
  padding: 8px 0 16px;
}

.profile-element {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-img {
  width: 56px;
  height: 56px;
  object-fit: cover;
  cursor: pointer;
  border: 2px solid rgba(129, 140, 248, 0.35);
  box-shadow: 0 0 0 4px rgba(79, 70, 229, 0.12);
}

.nav-header.small .profile-img {
  width: 36px;
  height: 36px;
}

.nav-header .block {
  color: #f1f5f9 !important;
  font-size: 0.82rem;
  margin-top: 10px !important;
}

.nav-header .text-muted {
  color: #8890a4 !important;
  font-size: 0.72rem;
}
</style>